/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateAliasNotificationSettingsRequest} from '@cash-web/protos/squareup/cash/notificationsettings/api/v1/update_alias_notification_settings.pb'
import {UpdateAliasNotificationSettingsResponse} from '@cash-web/protos/squareup/cash/notificationsettings/api/v1/update_alias_notification_settings.pb'


export const updateAliasNotificationSettings = (request: UpdateAliasNotificationSettingsRequest, options?: CashRequestOptions) => post<UpdateAliasNotificationSettingsRequest, UpdateAliasNotificationSettingsResponse>("/2.0/cash/update-alias-notification-settings", request, {...options, rejectOnError: true })